module.exports = __webpack_public_path__ + "static/img/overlay-hq.87e8981.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/overlay-hq.png
// module id = zr4b
// module chunks = 1